package org.hs_soft.runmynesto.domain.model.general

data class WindowSizeModel(
    val width:Int,
    val height:Int,
)